/**
 * Copyright (c) 2022, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
 * You may not alter or remove any copyright or other notice from copies of this content.
 */

import {
    APP_CLIENT_ID_STORAGE_KEY,
    APP_CLIENT_ID_TEMP_STORAGE_KEY,
    APP_CLIENT_ID_URL_SEARCH_PARAM_KEY,
    USERS_ORGANIZATION_STORAGE_KEY,
    USERS_ORGANIZATION_TEMP_STORAGE_KEY,
    USERS_ORGANIZATION_URL_SEARCH_PARAM_KEY
} from "../constants";

/**
 * Is the Sign-in button can be shown?
 *
 * @returns {boolean}
 */
export const canShowLogInButton = (): boolean => {

    return  window.sessionStorage.getItem(APP_CLIENT_ID_STORAGE_KEY) !== undefined
        && window.sessionStorage.getItem(USERS_ORGANIZATION_STORAGE_KEY) !== undefined;
};

/**
 * Get the Sign In URL.
 *
 * @returns {string}
 */
export const getSignInURL = (): string => {

    const clientId: string = window.sessionStorage.getItem(APP_CLIENT_ID_STORAGE_KEY) as string
        ?? window.sessionStorage.getItem(APP_CLIENT_ID_TEMP_STORAGE_KEY) as string;
    const organization: string = window.sessionStorage.getItem(USERS_ORGANIZATION_STORAGE_KEY) as string
        ?? window.sessionStorage.getItem(USERS_ORGANIZATION_TEMP_STORAGE_KEY) as string;
    const url: URL = new URL(window.location.origin);

    url.searchParams.set(APP_CLIENT_ID_URL_SEARCH_PARAM_KEY, clientId);
    url.searchParams.set(USERS_ORGANIZATION_URL_SEARCH_PARAM_KEY, organization);

    return url.href;
};

/**
 * Does the pre-requisite house keeping before a logout.
 *
 * @param cb {() => void} - callback function
 */
export const handleSignOut = (cb: () => void): void => {

    window.sessionStorage.setItem(APP_CLIENT_ID_TEMP_STORAGE_KEY,
        window.sessionStorage.getItem(APP_CLIENT_ID_STORAGE_KEY) as string);
    window.sessionStorage.setItem(USERS_ORGANIZATION_TEMP_STORAGE_KEY,
        window.sessionStorage.getItem(USERS_ORGANIZATION_STORAGE_KEY)  as string);
    window.sessionStorage.removeItem(USERS_ORGANIZATION_STORAGE_KEY);
    window.sessionStorage.removeItem(APP_CLIENT_ID_STORAGE_KEY);
    
    cb && cb();
};
